export const CHAT_SPLASH_SOURCE = 'chatSplash';
export const CHAT_SPLASH_FEATURE = 'Chat Splash';
export const CHAT_INVITATION_MODAL_SCREEN = 'Chat Invitation Modal';

export const chatSplashVerificationQueryParams = (
  senderId: string,
  method: string
) => ({
  returnTo: senderId,
  from: CHAT_SPLASH_SOURCE,
  method,
});

export const isChatSplashVerificationReturn = (
  source: string | null,
  senderId: string | null
) => source === CHAT_SPLASH_SOURCE && !!senderId;

export const chatSplashDmRoute = (senderId: string) => [
  '/chat/detail',
  senderId,
];
